import Icon from './Icon'
import IconStack from './IconStack'

export { IconStack }
export default Icon
